import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

export interface MenuItem {
  activatedRoute: ActivatedRoute;
  isHideHeader: boolean;
  backLevel: number;
  title: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {

  public breadcrumbs = new EventEmitter<MenuItem[]>();
  public breadcrumbsSnapshot: MenuItem[] = [];

  constructor() {

  }

  public updateBreadcrumbs(activatedRoute: ActivatedRoute): void {
    this.breadcrumbsSnapshot = this.createBreadcrumbs(activatedRoute.root);
    this.breadcrumbs.emit(this.breadcrumbsSnapshot);
  }

  private createBreadcrumbs(route: ActivatedRoute, breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    let parentBreadcrumb = breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1] : null;
    let breadcrumb: MenuItem = {
      activatedRoute: route,
      isHideHeader: parentBreadcrumb?.isHideHeader ?? false,
      backLevel: 1,
      title: ''
    }

    breadcrumb.title = route.snapshot.data['title'] ?? '';
    breadcrumb.isHideHeader = route.snapshot.data['isHideHeader'] ?? breadcrumb.isHideHeader;
    breadcrumb.backLevel = route.snapshot.data['backLevel'] ?? breadcrumb.backLevel;

    if (breadcrumb.title && !breadcrumbs.find(value => value.title === breadcrumb.title)) {
      breadcrumbs.push(breadcrumb);
    }

    if (children.length === 0) {
      this.breadcrumbs.emit(breadcrumbs);
      return breadcrumbs;
    } else {
      return this.createBreadcrumbs(children[0], breadcrumbs);
    }
  }
}
